import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'

export const Content = styled.div`
  display: flex;
  .nowrap {
    max-width: 32vw;

    ${iPadDown} {
      max-width: 72vw;
    }
  }
`

export const Main = styled.div`
  display: flex;
  flex-grow: 1;
`

interface ClickableProps {
  disabled: boolean
}

export const Clickable = styled.div<ClickableProps>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-grow: 1;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

export const Icon = styled.div`
  width: 6.09vw;

  ${iPadDown} {
    width: 11.5vw;
  }
`

export const Action = styled.div`
  span {
    align-items: center;
    display: flex;
    height: 100%;
    padding-left: 1.56vw;

    ${iPadDown} {
      padding-left: 4vw;
    }
  }
`

export const CheckboxWrapper = styled.div`
  margin-right: 1.56vw;

  ${iPadDown} {
    margin-right: 4vw;
  }
`
